export const PRODUCT_CARD_SIZE = {
  TILE_MINI: 'tile_mini',
  MINI: 'mini',
  MEDIUM: 'medium',
  RESPONSIVE: 'responsive',
} as const;
export type ProductCardSize = ValueOf<typeof PRODUCT_CARD_SIZE>;
